import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <span className={`eyebrow ${light ? "eyebrow-light" : ""} ${className}`}>{children}</span>
);

export const BtnLink = ({ to, variant = "gold", children, className = "", arrow = true, ...rest }) => (
  <Link to={to} className={`btn btn-${variant} ${className}`} {...rest}>
    <span>{children}</span>
    {arrow && <ArrowRight className="btn-arrow" size={17} aria-hidden="true" />}
  </Link>
);

export const SectionTitle = ({ eyebrow, title, light = false, center = false, className = "" }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
    {eyebrow && <Eyebrow light={light}>{eyebrow}</Eyebrow>}
    <h2 className={`mt-5 font-display text-4xl sm:text-5xl lg:text-[3.6rem] leading-[1.02] ${light ? "text-ivory" : "text-forest"}`}>
      {title}
    </h2>
  </div>
);
